module.exports = __webpack_public_path__ + "media/images/shapes/blurs/blur-1-8a76d69878cc31c437cc0c776c7e62871bccb91c95eafc4b7350eba9afdbdf1f.svg";